import Clinic from './clinics/clinic-searchbar.vue'

import Address from './addresses/address-searchbar.vue'

import Customer from './customers/customer-searchbar.vue'

import CompanyCustomer from './companies/companies-searchbar.vue'
import Employees from './employees/employees-searchbar.vue'
import Subscriptions from './subscriptions/subscriptions-searchbar.vue'

import UserFold from './customers/customer-foldout.vue'

import Card from './cards/card-searchbar.vue'

import Affiliate from './affiliates/affiliates-searchbar.vue'

import Product from './products/product-searchbar.vue'

import ProductFold from './products/product-foldout.vue'

import ProductDuration from './productsDurations/duration-searchbar.vue'

import Deviation from './deviations/deviations-searchbar.vue'

import AccountingPeriod from './accounting/accounting-searchbar.vue'

import User from './users/users-searchbar.vue'

import Quotation from './quotations/quotation-searchbar.vue'

Vue.component('Clinic', Clinic)
Vue.component('Address', Address)
Vue.component('Customer', Customer)
Vue.component('CompanyCustomer', CompanyCustomer)
Vue.component('Subscription', Subscriptions)
Vue.component('Employee', Employees)
Vue.component('UserFold', UserFold)
Vue.component('Card', Card)
Vue.component('Affiliate', Affiliate)
Vue.component('Product', Product)
Vue.component('ProductFold', ProductFold)
Vue.component('ProductDuration', ProductDuration)
Vue.component('Deviation', Deviation)
Vue.component('AccountingPeriod', AccountingPeriod)
Vue.component('User', User)
Vue.component('Quotation', Quotation)
